// Cache para valores de clientes e funcionários para evitar consultas repetidas
const clienteValorCache = new Map<string, { valor: number, timestamp: number }>();
const funcionarioValorCache = new Map<string, { valor: number, timestamp: number }>();
const CACHE_DURATION = 5 * 60 * 1000; // 5 minutos

export const getFromClienteCache = (cacheKey: string): number | null => {
  const cached = clienteValorCache.get(cacheKey);
  if (cached && (Date.now() - cached.timestamp) < CACHE_DURATION) {
    return cached.valor;
  }
  return null;
};

export const setClienteCache = (cacheKey: string, valor: number): void => {
  clienteValorCache.set(cacheKey, { valor, timestamp: Date.now() });
};

export const clearClienteCache = (): void => {
  clienteValorCache.clear();
};

export const getFromFuncionarioCache = (cacheKey: string): number | null => {
  const cached = funcionarioValorCache.get(cacheKey);
  if (cached && (Date.now() - cached.timestamp) < CACHE_DURATION) {
    return cached.valor;
  }
  return null;
};

export const setFuncionarioCache = (cacheKey: string, valor: number): void => {
  funcionarioValorCache.set(cacheKey, { valor, timestamp: Date.now() });
};
